import {useIntl} from 'react-intl'
import {KTIcon} from '../../_metronic/helpers'
import {CartWarning} from '../models/models'

export const OrderWarningsAlert = ({warnings}: {warnings?: CartWarning[] | null}) => {
  const intl = useIntl()

  if (!warnings?.length) return null

  return (
    <div
      className='notice d-flex bg-primary text-white rounded border border-primary p-6 mb-6'
      role='alert'
    >
      <span className='flex-shrink-0 me-4' aria-hidden='true'>
        <KTIcon iconName='information-5' iconType='solid' className='fs-2tx text-white' />
      </span>
      <div className='flex-grow-1'>
        <h4 className='text-white fw-bold mb-2'>
          {intl.formatMessage({id: 'ORDERS.CREATE_NEW_ORDER_WARNINGS_TITLE'})}
        </h4>
        <div className='d-flex flex-column gap-2 fs-6 text-white'>
          {warnings.map((warning, index) => (
            <div key={`${warning.code}-${index}`}>
              {intl.formatMessage({
                id: warning.code,
                defaultMessage: warning.description,
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
